module.exports = __webpack_public_path__ + "static/media/dt_charles_nye.cc509c20.png";